import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export function CTASection() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/register');
  };

  const handleLearnMore = () => {
    navigate('/');
    setTimeout(() => {
      const featuresSection = document.getElementById('features');
      if (featuresSection) {
        featuresSection.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <section className="py-12 sm:py-16 lg:py-20 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-yellow-600 via-yellow-500 to-orange-500 z-0"></div>
      <div className="absolute inset-0 bg-black/20 z-10"></div>
      
      <div className="relative z-20 container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">
        <div className="text-center space-y-8">
          <div>
            <h2 className="text-5xl sm:text-6xl lg:text-7xl font-extrabold text-white mb-4">
              {t('about.cta.brand')}
            </h2>
            <p className="text-white/90 text-2xl sm:text-3xl font-semibold">
              {t('about.cta.tagline')}
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
            <button 
              onClick={handleGetStarted}
              className="inline-flex items-center justify-center px-10 py-5 border border-transparent text-lg font-bold rounded-xl text-black bg-white hover:bg-gray-100 cursor-pointer whitespace-nowrap transition-ball duration-200 shadow-2xl hover:scale-105"
            >
              {t('about.cta.primaryButton')}
              <i className="ri-arrow-right-line ml-2 text-2xl"></i>
            </button>
            <button 
              onClick={handleLearnMore}
              className="inline-flex items-center justify-center px-10 py-5 border-2 border-white text-lg font-bold rounded-xl text-white bg-transparent hover:bg-white/10 cursor-pointer whitespace-nowrap transition-ball duration-200"
            >
              {t('about.cta.secondaryButton')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
